import React from 'react';
import { MapContainer } from '@components/organism/MapContainer';
import { Map } from '@components/atoms/Map';
import { RoundIcon, RoundIconVariants } from '@components/atoms/RoundIcon';
import styles from './MapDriver.module.css';
import { AvailabilityWithPicker } from '@components/organism/AvailabilityWithPicker/AvailabilityWithPicker';
import { useNavigate } from 'react-router-dom';

export function MapDriver() {
    const navigate = useNavigate();

    return (
        <MapContainer>
            <div className="position-relative w-100 h-100">
                <Map locations={[]} style={JSON.stringify({ height: '100%', width: '100%' })} />

                <div className="position-absolute top-0 z-3 p-4">
                    <RoundIcon
                        classes={styles.roundIcon}
                        icon="fa-thin fa-bars"
                        variant={RoundIconVariants.variant1}
                        onClick={() => navigate('/my-profile-driver')}
                    />
                </div>

                <div className="position-absolute bottom-0 w-100 z-2">
                    <AvailabilityWithPicker />
                </div>
            </div>
        </MapContainer>
    );
}
